<template>
  <v-flex fill-height lg12 md12>
    <v-card class="fill-height">
      <v-toolbar color="secondary" dense>
        <v-toolbar-title class="primarytext--text">Richieste confermate mensile</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-layout row wrap align-center justify-space-around>
          <v-flex align-self-start shrink pt-3>
            <v-date-picker
              v-model="date"
              :allowed-dates="allowedMonths"
              type="month"
              color="secondary lighten-1"
              locale="it-IT"
              :max="$moment().format('YYYY-MM')"
              @input="getReport"
              class="elevation-0"
            ></v-date-picker>
          </v-flex>
          <!--<v-divider inset></v-divider>-->
          <v-flex v-if="!!date" xs12 sm12 md8 lg8 align-self-start>
            <v-container fluid grid-list-md class="scroll-y">
              <v-data-iterator
                hide-actions
                :items="items"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                content-tag="v-layout"
                row
                wrap
              >
                <v-flex
                  slot="no-data"
                  align-self-center
                  class="title font-weight-light grey--text pa-3 text-xs-center"
                >Nessuna spesa nella data selezionata!</v-flex>
                <VerificaNoteCard
                  slot="item" 
                  slot-scope="props"
                  custom-class="lg4"
                  :item="props.item"
                  :key="props.item.identify"
                  :readonly="true"
                ></VerificaNoteCard>
              </v-data-iterator>
              <div class="text-xs-center pt-2" v-if="pages > 1">
                <v-pagination v-model="pagination.page" :length="pages" color="secondary"></v-pagination>
              </div>
            </v-container>
          </v-flex>
          <v-flex
            v-else
            xs12
            sm8
            md8
            lg8
            align-self-center
            class="title font-weight-light grey--text pa-3 text-xs-center"
          >Seleziona il mese del report!</v-flex>
        </v-layout>
      </v-layout>
    </v-card>
  </v-flex>

</template>

<script>
import VerificaNoteCard from "./VerificaNoteCard.vue";

export default {
  name: "acc-report-admin",
  components: {VerificaNoteCard},
  props: {},
  data() {
    return {
      loader: false,
      date: null,
      rowsPerPageItems: [3],
      pagination: {
        rowsPerPage: 2
      },
    };
  },
  computed: {
    items() {
      return this.$store.state.gestione.speseMensile;
    },
    pages() {
      return Math.ceil(this.items.length / this.pagination.rowsPerPage);
    },
  },
  methods: {
    allowedMonths: val => val,
    getReport: function(e) {
      this.$store.dispatch("gestione/getMensile", { data: this.date })
    },
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabReportMensileAdmin.vue